import { useStyletron } from "baseui";
import type { ReactNode } from "react";
import * as React from "react";
import ForkButtonSvg from "web/public/assets/fork-button.svg";
import { Callout } from "./Callout";

export const ForkButtonCallout = ({ domain, children }: { domain: string; children: ReactNode }) => {
  return (
    <Callout>
      {children}

      <ForkButton domain={domain} />
    </Callout>
  );
};

export const ForkButton = ({ domain }: { domain: string }) => {
  const [css, $theme] = useStyletron();
  return (
    <a href={`https://app.gadget.dev/auth/fork?domain=${domain}`} target="_blank" rel="noreferrer">
      <img className={css({ marginBottom: `${$theme.sizing.scale300} !important` })} src={ForkButtonSvg} alt="Fork on Gadget" />
    </a>
  );
};
